import { Cls_MobiFile } from "./global";

export class Cls_MobiConfirmationDialog {
  message!: string;
  title!: string;
  okButton!: string;
  cancelButton!: string;
}

export class Cls_MobiDynamicDialog {
  innerContent?: any;
  Title?: string;
  okButton?: string;
  cancelButton?: string;
  width = "99%";
  class: string[] = [];
}

export class Cls_MobiDynamicTableDialog {
  dialogHeading?: string = "Request Info";
  responseMessage: any[] = [];
  headerColumns: string[] = ["#", "Remark"];
  rowKeys: string[] = ["Code", "Remarks"];
}

export class Cls_MobiDocumentViewer {
  closeBtnText: string = "Close";
  closeBtnClass: string = "";
  FileList: Cls_MobiFile[] = [];
  selectedFileIndex: number = 0;
}
